import { authorisedFetch } from 'api/rest/authorisedFetch';
import { PaginationRequest, PaginationResponse } from 'data/common/models';
import { TRADERS_API_URL } from 'data/constants';
import {
  TraderDeposit,
  TraderDepositPaginationFilters,
} from 'data/traders/deposits/models/TraderDeposit';
import { parseItemStrict } from 'utils/parser/parseResponse';
import { encodeUrlParams } from 'utils/url/urlQueryUtils';

export async function getTraderDeposits(
  request: PaginationRequest<TraderDepositPaginationFilters>,
) {
  const result = await authorisedFetch(
    `${TRADERS_API_URL}/account/deposits?${encodeUrlParams(request)}`,
    {
      method: 'GET',
    },
  );

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to get available deposits: ${responseBody}`);
  }

  // Must go below previous response reading (in case of error)
  const data = await result.json();

  return parseItemStrict(PaginationResponse(TraderDeposit), data);
}
